export default __webpack_public_path__ + "static/media/invest_in_music.c92ddc09.png";